import { DrilldownTypes } from "../triage-v2";

export enum BicycleToolType {
  CUSTOM = "CUSTOM",
  ACTION = "ACTION",
  INSIGHT = "INSIGHT"
}
export interface BicycleToolTestCase {
  name: string;
  description: string;
  id: string;

  executionContext: DrilldownTypes.ExecutionContext;
}
export interface BicycleTool {
  name: string;
  description: string;
  id: string;

  codeExecutionToolSpec: DrilldownTypes.CodeExecutionToolSpec;
  requiredTools?: string[];

  testCases?: BicycleToolTestCase[];
  toolVersions?: Record<string, BicycleTool>;
  toolType?: BicycleToolType;
}

export interface BicycleToolList {
  tools: BicycleTool[];
}

export interface ExecuteCodeRequest {
  codeExecutionToolSpec: DrilldownTypes.CodeExecutionToolSpec;
  globalInformation: {
    tenantId: string;
    useCaseId: string;
  };
}

export interface ExecuteCodeResponse {
  codeExecutionResponse: DrilldownTypes.CodeExecutionResponse;
}
